import request from "@/router/axios"
export const list = (query) => {
    return request({
        url: `/api/sys/roleInfo/list`,
        method: 'post',
        data:query
    })
}
export const setPermission = (roleId, menuIds) => {
    return request({
        url: `/api/sys/roleInfo/setPermission`,
        method: 'post',
        params: {
            roleId,
            menuIds
        }
    })
}
export const getPermission = (roleId) => {
    return request({
        url: `/api/sys/roleInfo/getPermission`,
        method: 'get',
        params: {
            roleId
        }
    })
}